import dayjs from "dayjs";
import ParticipantActionButtons from "./ParticipantActionButtons";
import { DatePicker } from "@mui/x-date-pickers";
import { Gender, getGenderOptions } from "../../../interfaces/enums";
import { Person } from "@mui/icons-material";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

interface Props {
  editData: { firstName: string; lastName: string; birthDate: Date; gender: Gender };
  onChange: (data: Partial<Props["editData"]>) => void;
  onSave: () => void;
  onCancel: () => void;
}

export default function ParticipantListItemEdit({ editData, onChange, onSave, onCancel }: Props) {
  return (
    <ListItem
      sx={{ py: 2, px: { xs: 2, sm: 3 }, backgroundColor: "#f8f9fa", border: "2px solid #6366f1" }}
    >
      <Grid container spacing={2} sx={{ width: "100%" }}>
        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
            <Person sx={{ color: "#6366f1", fontSize: 20 }} />
            <TextField
              size="small"
              label="Imię"
              value={editData.firstName}
              onChange={(e) => onChange({ firstName: e.target.value })}
              sx={{ minWidth: "120px" }}
            />
            <TextField
              size="small"
              label="Nazwisko"
              value={editData.lastName}
              onChange={(e) => onChange({ lastName: e.target.value })}
              sx={{ minWidth: "120px" }}
            />
            <DatePicker
              label="Data urodzenia"
              value={editData.birthDate ? dayjs(editData.birthDate) : null}
              onChange={(newValue) =>
                onChange({ birthDate: newValue ? newValue.toDate() : editData.birthDate })
              }
              slotProps={{ textField: { size: "small", sx: { minWidth: "140px" } } }}
              format="DD.MM.YYYY"
              disableFuture
            />
            <FormControl size="small" sx={{ minWidth: "100px" }}>
              <InputLabel>Płeć</InputLabel>
              <Select
                value={editData.gender}
                label="Płeć"
                onChange={(e) => onChange({ gender: e.target.value as Gender })}
              >
                {getGenderOptions().map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12} md={2}>
          <ParticipantActionButtons mode="edit" onSave={onSave} onCancel={onCancel} />
        </Grid>
      </Grid>
    </ListItem>
  );
}
